export default __webpack_public_path__ + "images/RF.27b6cba.png";